export const DEFAULT_LOCALE = 'de-DE';
export const DEFAULT_CURRENCY = 'EUR';